
import axios from 'axios';
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';


export default {
    data() {
          return {
            selected_page: 'Books',
            sideoptions: [
                'Books',
                'FAQs',
                'Feedback & Suggestions',
                'Tile Content Display',
                'Manage Sessions'
            ],
            web_only_switch: this.$store.getters.web_only, //false
            book_code: "",
            booksAndDesc: [],
            booksStatus: [],
            side_bar_page: false,
            emoji: "",
            feedback: "",
            final_feedback_msg: "",
            environment: "",
            stage_uber_template: "66ff12f1-813f-5dd4-85fb-73e737e671e5",
            uat_uber_template: "66ff12f1-813f-5dd4-85fb-73e737e671e5",
            prod_uber_template: "db94e511-ae6c-5dbb-abab-314e5118d70e",
            buttons_disabled: false,
            feedback_modal: false,
            session_list: [],
            user_id: 0,
            otpsession: false,
            otpinput: "",
            otpsent: false,
        }
      },
    computed:{
      ...mapGetters(['authenticated',
                     'auth_token',
                     'auth_user',
                     'books',
                     'web_only',
                     'ubertoken',
                     'active_books',
                     'book_and_desc',
                     'tile_view_display',
                     'vuexLoaderTrigger'
                    ]),
    },
    

 mounted() {
        console.log("MOUNTED");

        this.environment = this.app_environment;

        if (this.$store.getters.active_books.length == 0) {
            this.$store.getters.books.map((item, index) => {
                if (index === 0) {
                   if (this.$store.getters.selected_book == "") {    
                       this.$store.dispatch('activeBook', item);
                   }
                }
                this.$store.dispatch("setActiveBooks", item);
            });
        }

        this.loadSessionList();
        this.loadBooks();
        this.sortBooks();


        axios({
            method: "post",
            url: this.baseAPIURL+"/apiv3/getubertoken.json",
            headers: {
                "auth": this.$store.getters.auth_token,
                "Content-Type": "multipart/form-data",
            },
        })
        .then(response => {
            //handle success
             if (response.data.code === 200) {
                 this.$store.dispatch('setUbertoken', response.data.response.data.token);
             }
        });

       
  },
  methods: {

    verifyotpsession() {
        console.log(this.otpinput);

        axios({
            method: "post",
            url: this.baseAPIURL+"/apiv3/confirmotp.json",
            data: { 
                email: this.$store.getters.auth_user,
                code: this.otpinput,
            },
            headers: {
                "auth": this.$store.getters.auth_token,
                "Content-Type": "application/json",
            },
        })
        .then(response => {
            //handle success
            console.log(response);
            if (response.data.status == "success") {
                this.$moshaToast("OTP Verified", { type: "success" });
                this.otpsession = true;
            } else {
                this.$moshaToast("The OTP is invalid. Please re-enter it or request a new one.", { type: "danger" });
            }
           
        }).catch(error => {
        // Handle error
            console.error("Error logging out:", error);

            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong while logging out!',
            });
        });
    },

    reloadsessionslist() {
        this.session_list = [];
        this.loadSessionList();
    },

    logoutofalldevices(user_id) {
        Swal.fire({
            title:"Are you sure?",
            text: "You're about to logout of all devices except this session, continue?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, logout all other devices!',
            cancelButtonText: 'No, keep me logged in',
            customClass: {
                confirmButton: 'px-6 py-2 text-white bg-red-600 rounded-lg hover:bg-red-900 mx-2 my-2 border border-blue-600',
                cancelButton: 'px-6 py-2 text-white bg-blue-400 rounded-lg hover:bg-blue-600 mx-2 my-2 border border-blue-600'
            }
           }).then( (result) => {
                if (result.isConfirmed) {
                    axios({
                        method: "post",
                        url: this.baseAPIURL+"/apiv3/logoutalldevices.json",
                        data: { user_id: user_id},
                        headers: {
                            "auth": this.$store.getters.auth_token,
                            "Content-Type": "application/json",
                        },
                    })
                    .then(response => {
                        //handle success
                        console.log("Logged out successfully!", response);
                        this.session_list = [];
                        this.$moshaToast("All of your other sessions have been successfully logged out.", { type: "warning" });
                        
                        this.loadSessionList();
                    }).catch(error => {
                    // Handle error
                        console.error("Error logging out:", error);
            
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Something went wrong while logging out!',
                        });
                    });
                } else {
                    console.log("Cancelled");
                }
           });
    },

    logoutsession(id) {
       Swal.fire({
        title:"Are you sure?",
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, logout this session!',
        cancelButtonText: 'No, keep me logged in',
        customClass: {
            confirmButton: 'px-6 py-2 text-white bg-red-600 rounded-lg hover:bg-red-900 mx-2 my-2 border border-blue-600',
            cancelButton: 'px-6 py-2 text-white bg-blue-400 rounded-lg hover:bg-blue-600 mx-2 my-2 border border-blue-600'
        }
       }).then( (result) => {
            if (result.isConfirmed) {
                this.logoutthis(id);
            } else {
                console.log("Cancelled");
            }
       });
    },

    logoutthis(session_id) {
        axios({
            method: "post",
            url: this.baseAPIURL+"/apiv3/removesession.json",
            data: { session_id: session_id},
            headers: {
                "auth": this.$store.getters.auth_token,
                "Content-Type": "application/json",
            },
        })
        .then(response => {
            //handle success
            console.log("Logged out successfully!", response);
            this.session_list = this.session_list.filter(session => session.id !== session_id);
            
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'You removed that session!',
            });


        }).catch(error => {
        // Handle error
            console.error("Error logging out:", error);

            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong while logging out!',
            });
        });
    },

    formatDate(date) {
        const sessionDate = new Date(date);
        return sessionDate.toLocaleString("en-US", {
          year: "numeric", // e.g. 2025
          month: "long", // e.g. March
          day: "numeric", // e.g. 3
          hour: "2-digit", // e.g. 11
          minute: "2-digit", // e.g. 47
          second: "2-digit", // e.g. 10
          hour12: true, // AM/PM format
        })
    },
    loadSessionList(){
        axios({
            method: "get",
            url: this.baseAPIURL+"/apiv3/sessionlist.json",
            headers: {
                "auth": this.$store.getters.auth_token,
                "Content-Type": "multipart/form-data",
            },
        })
        .then(response => {
            let responseData = response.data;  // Assuming response.data is a string
            this.session_list = responseData.data;
            this.user_id = responseData.data[0].user_id;
        });
    },
    loadBooks(){
        for ( var i=0; i < this.$store.getters.books.length; i++) {
            var bodyFormData = new FormData();
            bodyFormData.append("code", this.$store.getters.books[i]);
                axios({
                    method: "post",
                    url: this.baseAPIURL+"/apiv3/getbook.json",
                    data: bodyFormData,
                    headers: {
                        "auth": this.$store.getters.auth_token,
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(response => {
                    //handle success
                    this.$store.dispatch('setBookAndDesc', {"title":response.data.books[0].code, "desc":response.data.books[0].description});
                });
        }

    },
    sortBooks(){
        axios({
            method: "get",
            url: this.baseAPIURL+"/apiv3/getDomainSort.json",
            headers: {
                "auth": this.$store.getters.auth_token,
                "Content-Type": "multipart/form-data",
            },
        })
        .then(response => {
            let responseData = response.data;
        
            try {
                var preload_books_sorted = [];
        
                // Extract mappings
                var domain_auto = responseData.data.domain_auto || {};
                var default_books_map = responseData.data.default || {};
                var book_desc = this.$store.getters.book_and_desc;
        
                // Sort orders (IDs)
                var domain_book_sorts = Object.values(responseData.data.domain_book_sorts || {});
                var default_book_sorts = Object.values(responseData.data.default_book_sorts || {});
        
                // Map domain IDs → titles
                domain_book_sorts.forEach(id => {
                    let title = domain_auto[id];
                    if (title && !preload_books_sorted.includes(title)) {
                        preload_books_sorted.push(title);
                    }
                });
        
                // Map default IDs → titles
                default_book_sorts.forEach(id => {
                    let title = default_books_map[id];
                    if (title && !preload_books_sorted.includes(title)) {
                        preload_books_sorted.push(title);
                    }
                });
        
                // Reorder actual book objects
                const reorderedBooks = [
                    ...preload_books_sorted
                        .map(title => book_desc.find(book => book.title === title))
                        .filter(Boolean),
                    ...book_desc.filter(book => !preload_books_sorted.includes(book.title))
                ];
        
                // Replace store data
                this.$store.dispatch('resetBooksAndDesc');
                reorderedBooks.forEach(book => {
                    this.$store.dispatch('setBookAndDesc', {
                        title: book.title,
                        desc: book.desc
                    });
                });
        
            } catch (error) {
                console.error("Error parsing JSON:", error.message);
            }
        });
    },
    checkToggleButtonBook(book_title){
        if (this.$store.getters.active_books.includes(book_title) && this.$store.getters.active_books.length == 1) {
            this.$moshaToast("Can’t deactivate last book. There should be at least one book activated.", { type: "warning" });
        }
    },
    checkToggleTileDisplay(){
        if (this.$store.getters.tile_view_display === "Default") {
            this.$store.dispatch('updateTileViewDisplay', "Progressive");
            this.$moshaToast("The tile content is now in Pagination View", { type: "success" });
        } else {
            this.$store.dispatch('updateTileViewDisplay', "Default");
            this.$moshaToast("The tile content is now in Scrollable View", { type: "success" });
        }
    },
    toggleBooks(book_title) {

            
                if (this.$store.getters.active_books.includes(book_title)) { //check if it includes
                    if (this.$store.getters.active_books.length == 2) {
                        this.$store.dispatch('unsetActiveBooks', book_title);
                        this.$store.dispatch('activeBook', this.$store.getters.active_books[0]);
                    } else {
                        this.$store.dispatch('unsetActiveBooks', book_title);
                        this.$store.dispatch('activeBook', this.$store.getters.active_books[0]);
                    }
                } else {
                    this.$store.dispatch('setActiveBooks', book_title);
                }
           
            
    },

    // disableCheck() {
    //     console.log("DISABLE");
    // },
    
    toggleWebOnlySwitch() {
        if (this.web_only_switch == true) {
            this.$store.dispatch('setWebOnly', true);
        } else {
            this.$store.dispatch('setWebOnly', false);
        }
        
        this.$moshaToast("Changes Applied", { type: "success" });
    },

    sendotpsession(){
              axios({
                  method: "post",
                  url: this.baseAPIURL+"/apiv3/sendotp.json",
                  data: { email: this.$store.getters.auth_user},
                  headers: {
                      "auth": this.$store.getters.auth_token,
                      "Content-Type": "application/json",
              },
              })
              .then(response => {
                  //handle success
                  console.log("Sent otp!", response);
                  if (response.data.status == "success") {
                    this.$moshaToast("An OTP has been sent to your email ("+this.$store.getters.auth_user+") for verification. ", { type: "success" });
                    this.otpsent = true;
                  } else {
                    this.$moshaToast("You're requesting too fast. "+response.data.message+"", { type: "danger" });
                  }
              
              }).catch(error => {
              // Handle error
                  console.error("Error logging out:", error);
    
                  Swal.fire({
                      icon: 'error',
                      title: 'Oops...',
                      text: error,
                  });
              });
    },

    selectPage(page){
           this.clearFeedbackSuggestions();
           this.book_code = "";
           this.selected_page = page;

           
    },
    changeEmoji(value){
            if (value == 1){
                this.emoji = "Bad";
            } else if (value == 2) {
                this.emoji = "Neutral";
            } else if (value == 3) {
                this.emoji = "Great";
            }
    },
    submitFeedbackSuggestions(){
        this.buttons_disabled = true;

        if (this.emoji === "" || this.feedback === ""){
            this.$moshaToast("Please complete the form by selecting an emoji and typing a feedback.", { type: "danger" });
            this.buttons_disabled = false;
        } else {
            // var formData = new FormData();
            this.final_feedback_msg = "["+this.emoji+"] "+this.feedback;



            if (this.environment == "local" || this.environment == "stage" || this.environment == "staging") {
                var requestData = {
                    "template_id": this.stage_uber_template,
                    "16236": "Tap Web - "+this.environment,
                    "16238": this.appVersion,
                    "16235": this.final_feedback_msg
                };
            } else if (this.environment == "uat") {
                requestData = {
                    "template_id": this.stage_uber_template,
                    "16236": "Tap Web - "+this.environment,
                    "16238": this.appVersion,
                    "16235": this.final_feedback_msg
                };
            } else if (this.environment == "prod" || this.environment == "production") {
                requestData = {
                    "template_id": this.prod_uber_template,
                    "21512": "Tap Web - "+this.environment,
                    "21514": this.appVersion,
                    "21511": this.final_feedback_msg
                };
            }

            axios({
                method: "post",
                url: this.uber_api+"/integrations/v1/my/tickets",
                data: requestData,
                headers: { Authorization: "Bearer "+this.$store.getters.ubertoken }
            })
            .then(() => {
                //handle succes
                this.buttons_disabled = false;
                this.clearFeedbackSuggestions();
                this.feedback_modal = true;

            }).catch(error => {
                console.log("Error: "+ error);
                this.$moshaToast("Something went wrong.", { type: "danger" });
            });
        }
    },
    clearFeedbackSuggestions(){
        this.emoji = "";
        this.feedback = "";
    },
    closeSuccessModal(){
        this.feedback_modal = false;
    },
    addBook(){

            if (this.$store.getters.books.includes(this.book_code.toUpperCase())) {
                this.$moshaToast(this.book_code.toUpperCase()+" is already added.", { type: "warning" });
                
            } else {
                var bodyFormData = new FormData();
                bodyFormData.append("code", this.book_code);

                axios({
                    method: "post",
                    url: this.baseAPIURL+"/apiv3/getbook.json",
                    data: bodyFormData,
                    headers: {
                        "auth": this.$store.getters.auth_token,
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(response => {
                    //handle succes
                        var responseData = JSON.parse(JSON.stringify(response.data.books));
                        this.$store.dispatch('addBook', responseData[0].code);
                        
                        this.$store.dispatch('setActiveBooks', responseData[0].code);
                        
                        this.booksAndDesc.push({"title":response.data.books[0].code, "desc":response.data.books[0].description});
                        this.$moshaToast(response.data.books[0].code+" successfully added!", { type: "success" });
                }).catch(error => {
                    console.log("Error: "+ error);
                    this.$moshaToast("No access to book!", { type: "danger" });
                });

            }
            
            this.book_code = "";
    }
      
  }
}